import { render } from "./Topblock.vue?vue&type=template&id=5de091be"
import script from "./Topblock.vue?vue&type=script&lang=js"
export * from "./Topblock.vue?vue&type=script&lang=js"

import "./Topblock.vue?vue&type=style&index=0&id=5de091be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__